import { useActionState } from 'react';
import useSettings from '@/hooks/useSettings';
import { fromTimeString } from './timeStrings';
import type { SettingsType } from '../SettingsContext';

function useSettingsForm(onSubmit?: () => void) {
  const { update, ...settings } = useSettings();

  async function updateSettings(state: SettingsType, formData: FormData) {
    const newSettings: Partial<SettingsType> = {};
    formData.forEach((value, key) => {
      if (key in state && !(value instanceof File)) {
        newSettings[key as keyof SettingsType] = value.includes(':') ? fromTimeString(value) : Number(value);
      }
    });
    update(newSettings);
    if (onSubmit) {
      onSubmit();
    }
    return newSettings as SettingsType;
  }

  return useActionState(updateSettings, settings);
}

export default useSettingsForm;
